import { fetcher } from "@repo/api";
import { type ApiError } from "@repo/api/src/ApiError";
import useSWR from "swr";

import { useSettings } from "../settings/SettingsProvider";

type StoresResponse = Record<string, string>;

export function useStores() {
  const { market } = useSettings();

  return useSWR<StoresResponse, ApiError>(
    market ? `/stores?country=${market.toUpperCase()}` : null,
    async (url) => {
      const res = (await fetcher.global.get<StoresResponse>(url)) ?? {};
      return res;
    },
    {
      revalidateOnFocus: false,
      dedupingInterval: 5 * 60 * 1000,
    }
  );
}

export const mapStores = (stores: StoresResponse | undefined) => {
  return Object.fromEntries(
    Object.entries(stores ?? {}).map(([key, value]) => [
      key,
      `${value} (${key})`,
    ])
  );
};
